import React, { useState, useEffect, useContext } from "react";
import Banner from "../../components/Banner/Banner";
import Pagination from "../../components/pageProps/shopPage/Pagination";
import { UserConfigContext } from "../../context/UserConfigContext";
import { FaShoppingCart } from 'react-icons/fa';
import { loadNews, paginationItems2, paginationItems, loadProducts } from "../../constants/products";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addToCart } from "../../redux/orebiSlice";
import posterImg from "../../assets/images/logo_hinet.jpeg"; // imagen local

const Home = () => {
  const [itemsPerPage, setItemsPerPage] = useState(12);
  const { config1, config2 } = useContext(UserConfigContext);
  const [productList, setProductList] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const [hasNews, setHasNews] = useState(false);
  const [videoReady, setVideoReady] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const verMas = sessionStorage.getItem("verMas") === "true";
    setShowMore(verMas);
  }, [location]);

  useEffect(() => {
    const fetchProducts = async () => {
      await loadNews(1, 5, "", 0, 0, 0);
      let filtered = paginationItems2.filter(item => item.img);

      if (filtered.length === 0) {
        await loadProducts(1, 5, "", 0, 0, 0);
        filtered = paginationItems.filter(item => item.img);
      }

      setProductList(filtered);
      // setHasNews(filtered.length > 0);
    };

    fetchProducts();
  }, []);

  // Armar cuadrante desde config2.cuadrante
  const imageCategories = Array.isArray(config1?.cuadrante)
    ? config1.cuadrante.map(cuadra => ({
        href: cuadra.url_destino || "#",
        imgSrc: cuadra.rutaimagen || "",
        alt: cuadra.grupo_nombre || "Sin nombre",
      }))
    : [];

  // Función para generar slug
  const idString = (name) => {
    return String(name)
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/[^\w-]/g, "");
  };
  // console.log(hasNews, showMore)
  // return false;

  return (
    <div className="w-full mx-auto">
      {config2.vista.carousel_home === 1 && !showMore && <Banner />}

      {config2.vista.muestra_cuadrante === 1 && imageCategories.length === 4 &&
      !showMore && (
        <section className="section-category section-category--desktop section-category--standard my-8 max-h-[600px] overflow-hidden">
          <div className="max-w-[1200px] mx-auto px-4 flex gap-x-4 h-full">
            
            {/* Columna izquierda */}
            <div className="flex-1 flex flex-col justify-between gap-y-4 h-full">
              {imageCategories.slice(0, 2).map(({ href, imgSrc, alt }, i) => {
                const isVimeo = imgSrc.includes("vimeo.com");
                const isVideoFile = /\.(mp4|webm|ogg)$/i.test(imgSrc);

                return (
                  <a key={i} href={href} target="_self" rel="noopener noreferrer" className="block w-full">
                    <div className="w-full relative overflow-hidden rounded-none aspect-video group"> 

                      {/* Imagen de fondo mientras carga */}
                      {!videoReady && (
                        <img
                          src={posterImg} // 👈 imagen de fondo
                          alt={alt}
                          className="absolute inset-0 w-full h-full object-cover rounded-md z-10"
                        />
                      )}

                      {/* 🔹 Ahora todas tienen el mismo aspect ratio */}
                      {isVimeo ? (
                        <iframe
                          src={`${imgSrc}?title=0&byline=0&portrait=0&autopause=0&autoplay=1&loop=1&muted=1&background=1`}
                          allow="autoplay; fullscreen"
                          allowFullScreen
                          className="absolute inset-0 w-full h-full object-cover border-0 rounded-md"
                          onLoad={() => setVideoReady(true)}   // 👈 cuando carga
                        />
                      ) : isVideoFile ? (
                        <video
                          src={imgSrc}
                          autoPlay
                          loop
                          muted
                          playsInline
                          className="absolute inset-0 w-full h-full object-cover rounded-md"
                          onLoadedData={() => setVideoReady(true)} // 👈 listo para reproducir
                        />
                      ) : (
                        <img
                          decoding="async"
                          src={imgSrc}
                          alt={alt}
                          className="absolute inset-0 w-full h-full object-cover rounded-md"
                        />
                      )}

                      {/* Overlay */}
                      <div
                        className="absolute inset-0 bg-black/0 
                                  group-hover:bg-black/40 
                                  transition-colors duration-300 
                                  object-cover rounded-md">
                      </div>

                    </div>
                  </a>
                );
              })}
            </div>

            {/* Columna derecha */}
            <div className="flex-1 flex flex-col justify-between gap-y-4 h-full">
              {imageCategories.slice(2, 4).map(({ href, imgSrc, alt }, i) => {
                const isVimeo = imgSrc.includes("vimeo.com");
                const isVideoFile = /\.(mp4|webm|ogg)$/i.test(imgSrc);

                return (
                  <a key={i + 2} href={href} target="_self" rel="noopener noreferrer" className="block w-full">
                    <div className="w-full relative overflow-hidden rounded-none aspect-video group"> 
                      
                      {/* Imagen de fondo mientras carga */}
                      {!videoReady && (
                        <img
                          src={posterImg} // 👈 imagen de fondo
                          alt={alt}
                          className="absolute inset-0 w-full h-full object-cover rounded-md z-10"
                        />
                      )}

                      {/* 🔹 Igual aspecto que las de la izquierda */}
                      {isVimeo ? (
                        <iframe
                          src={`${imgSrc}?title=0&byline=0&portrait=0&autopause=0&autoplay=1&loop=1&muted=1&background=1`}
                          allow="autoplay; fullscreen"
                          allowFullScreen
                          className="absolute inset-0 w-full h-full object-cover border-0 rounded-md"
                          onLoad={() => setVideoReady(true)}   // 👈 cuando carga
                        />
                      ) : isVideoFile ? (
                        <video
                          src={imgSrc}
                          autoPlay
                          loop
                          muted
                          playsInline
                          className="absolute inset-0 w-full h-full object-cover rounded-md"
                          onLoadedData={() => setVideoReady(true)} // 👈 listo para reproducir
                        />
                      ) : (
                        <img
                          decoding="async"
                          src={imgSrc}
                          alt={alt}
                          className="absolute inset-0 w-full h-full object-cover rounded-md"
                        />
                      )}

                      {/* Overlay */}
                      <div
                        className="absolute inset-0 bg-black/0 
                                  group-hover:bg-black/40 
                                  transition-colors duration-300 
                                  object-cover rounded-md">
                      </div>

                    </div>
                  </a>
                );
              })}
            </div>
          </div>
        </section>
      )}

      {hasNews && !showMore && (
        <section className="py-10 bg-white">
          <div className="max-w-[1200px] mx-auto px-4">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-2xl font-bold">Productos Destacados</h3>
              <button
                onClick={() => {
                  sessionStorage.setItem("verMas", "true");
                  setShowMore(true);
                }}
                className="text-blue-600 hover:underline text-sm font-medium"
              >
                Ver más
              </button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
              {productList.slice(0, 5).map((item, index) => {
                const rootId = idString(item.Descripcion);
                return (
                  <div
                    key={index}
                    className="border p-3 relative flex flex-col h-full"
                  >
                    {/* Imagen clickeable */}
                    <div
                      className="relative cursor-pointer"
                      onClick={() =>
                        navigate(`/product/${rootId}`, {
                          state: { item: item },
                        })
                      }
                    >
                      <img
                        src={item.img}
                        alt={item.Descripcion}
                        className="w-full h-48 object-contain"
                      />
                    </div>

                    <div className="mt-3 flex flex-col flex-grow">
                      <p className="text-xs text-gray-500">
                        {item.categoria || "General"}
                      </p>
                      {/* Descripción */}
                      <h4
                        className="text-sm font-semibold cursor-pointer hover:underline line-clamp-2"
                        onClick={() =>
                          navigate(`/product/${rootId}`, {
                            state: { item: item },
                          })
                        }
                      >
                        {item.Descripcion}
                      </h4>

                      {/* Contenedor precio + botón pegado abajo */}
                      <div className="mt-auto flex flex-col gap-2">
                      <div className="flex items-center space-x-2">
        {item.PrecioOferta ? (
          <>
            <span className="text-red-500 font-bold">
              {item.simbolo}
              {Number(item.PrecioOferta || 0).toFixed(2)}
            </span>
            {item.PrecioLista && (
              <del className="text-gray-400 text-sm">
                {item.simbolo}
                {Number(item.PrecioLista || 0).toFixed(2)}
              </del>
            )}
          </>
        ) : (
          item.PrecioLista && (
            <span className="text-red-500 font-bold">
              {item.simbolo}
              {Number(item.PrecioLista || 0).toFixed(2)}
            </span>
          )
        )}
      </div>

                        <button
                          className="w-full bg-white border-2 border-black text-black font-bold py-1 rounded-full flex items-center justify-center gap-2 text-sm hover:bg-gray-100"
                          onClick={() => {
                            dispatch(addToCart({ ...item, quantity: 1 }));
                          }}
                        >
                          <FaShoppingCart /> Agregar al Carrito
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      )}

      {(!hasNews || showMore) && (
        <div className="max-w-container mx-auto px-4">
          <div className="w-full h-full flex pb-20 gap-10">
            <div className="w-full h-full flex flex-col gap-10 mt-3">
              <Pagination itemsPerPage={itemsPerPage} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
